import { render, staticRenderFns } from "./FeatureAgency.vue?vue&type=template&id=47fb7ba2&"
import script from "./FeatureAgency.vue?vue&type=script&lang=js&"
export * from "./FeatureAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports